import React, { useCallback, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Stack, Link, Container, Typography, styled, CircularProgress } from '@mui/material';
// layouts
import AuthLayout from 'layouts/AuthLayout';
// components
import Page from 'components/Page';
// import { LoginForm } from 'sections/authentication/login';
import Config from 'config';
import { useDispatch } from 'react-redux';
import {
  setExpire,
  setFullName,
  setUserGroup,
  setUserId,
  setUserName
} from 'sections/authentication/login/loginSlice';
import { add } from 'date-fns';
import { ApiGetProfile } from 'api';
import { LoginForm } from 'sections/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  // const dispatch = useDispatch();
  // const AUTHENTICATION_URL = Config.getValue('REACT_APP_AUTHENTICATION_URL');
  // const accessToken = localStorage.getItem('accessToken');
  // const hasToken = !!accessToken ?? false;

  // const afterLogin = useCallback(async () => {
  //   try {
  //     localStorage.setItem('access_token', accessToken);
  //     localStorage.setItem('refresh_token', accessToken);
  //     console.log('localStorage', localStorage);
  //     const user = await ApiGetProfile();
  //     console.log('user.data', user.data);
  //     const { id, email, firstName, lastName, role } = user.data;
  //     dispatch(setUserId(id));
  //     dispatch(setUserName(email));
  //     dispatch(setUserGroup([role]));
  //     dispatch(setExpire(add(new Date(), 365)));
  //     dispatch(setFullName({ name: firstName, surname: lastName }));
  //     window.location.href = `${process.env.PUBLIC_URL}/dashboard/app`;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }, [accessToken, dispatch]);

  // useEffect(() => {
  //   if (!hasToken) {
  //     setTimeout(() => {
  //       window.location.href = `${AUTHENTICATION_URL}?refer=${encodeURIComponent(
  //         window.location.href
  //       )}`;
  //     }, 1000);
  //   } else {
  //     afterLogin();
  //   }
  // }, [AUTHENTICATION_URL, hasToken, afterLogin]);

  return (
    <RootStyle title="Login | Aquatic monitoring system">
      <AuthLayout />

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom align="center">
              Sign in to Aquatic Monitoring System
            </Typography>
            {/* <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography> */}
          </Stack>
          {/* <AuthSocial /> */}

          <LoginForm />
          {/* <Stack
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <CircularProgress size={80} />
          </Stack> */}

          <Typography
            variant="body2"
            align="center"
            sx={{
              mt: 3,
              display: { sm: 'none' }
            }}
          >
            Don’t have an account?&nbsp;
            <Link variant="subtitle2" component={RouterLink} to="register" underline="hover">
              Get started
            </Link>
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
